// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setChartId = createAction('[Scatter Plot] Set Chart Id', props());
